// polyfills for ie10
import '@/services/polyfills'
import 'es6-promise/auto'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import store from './store'
import router from './router'

Vue.config.productionTip = false

// https://github.com/vuejs-templates/webpack/issues/215#issuecomment-287652462
new Vue({
  router,
  store,
  render: createEle => createEle(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js